// var app1_op = 1;

export function initialize() {
  var option = {
    color: [
      "#03B3EE",
      "#10D1B4",
      "#F0886F",
      "#A485FA",
      "#FADE61",
      "#1453e0",
      "#32b40b",
      "#c88b15",
      "#4c5b6c",
      "#d73110"
    ],
    tooltip: {
      trigger: "item"
    },
    legend: {
      show: false,
      orient: "vertical",
      y: "120px",
      x: "30px",
      data: ["辣椒干"],
      textStyle: {
        color: "#fff"
      }
    },
    toolbox: {
      show: false,
      orient: "vertical",
      x: "right",
      y: "center",
      feature: {
        mark: {
          show: true
        },
        dataView: {
          show: true,
          readOnly: false
        },
        restore: {
          show: true
        },
        saveAsImage: {
          show: true
        }
      }
    },
    dataRange: {
      show: false,
      min: 0,
      max: 100,
      calculable: true,
      color: ["#ff3333", "orange", "yellow", "lime", "aqua"],
      textStyle: {
        color: "#fff"
      }
    },
    series: [
      {
        name: "全国",
        type: "map",
        roam: true,
        hoverable: false,
        mapType: "none",
        itemStyle: {
          normal: {
            borderColor: "rgba(100,149,237,1)",
            borderWidth: 0.5,
            areaStyle: {
              color: "#1b1b1b"
            }
          }
        },
        data: [],
        markLine: {
          //基础划线
          smooth: true,
          symbol: ["none", "circle"],
          symbolSize: 1,
          itemStyle: {
            normal: {
              color: "#fff",
              borderWidth: 1,
              borderColor: "rgba(30,144,255,0.5)"
            }
          },
          data: []
        },
        geoCoord: {
          茂名市: [110.931543, 21.669064],
          乳源: [113.31292767257337, 24.831617310766855],
          高要市: [112.45834, 23.02577],
          大埔县: [116.7344736676842, 24.311903619148012],
          梅江区: [116.15797294936779, 24.282298482542696],
          信宜市: [111.25376859291828, 22.425151343786048],
          罗定市: [111.53513985685771, 22.66964096213511],
          兴宁市: [115.62020856797513, 24.306242186803463],
          阳东区: [112.1801897053547, 21.902805359829525],
          天津市: [117.4219, 39.4189],
          河北省: [114.519921, 38.049338],
          山西省: [112.56272, 37.87343],
          内蒙古自治区: [111.76522, 40.81733],
          辽宁省: [123.42925, 41.83571],
          鞍山市: [123.001373, 41.115054],
          黑龙江省: [126.66285, 45.74208],
          吉林省: [126.482548, 43.64646],
          上海市: [121.4648, 31.2891],
          江苏省: [118.76295, 32.06071],
          浙江省: [120.1536, 30.26555],
          安徽省: [117.29, 32.0581],
          福建省: [119.4543, 25.9222],
          江西省: [116.0046, 28.6633],
          山东省: [117.1582, 36.8701],
          河南省: [113.4668, 34.6234],
          湖北省: [114.3896, 30.6628],
          湖南省: [113.0823, 28.2568],
          广东省: [113.12244, 23.009505],
          广西壮族自治区: [108.479, 23.1152],
          海南省: [110.3893, 19.8516],
          重庆市: [108.384366, 30.439702],
          四川省: [103.9526, 30.7617],
          贵州省: [106.6992, 26.7682],
          云南省: [102.9199, 25.4663],
          西藏自治区: [91.11, 29.97],
          陕西省: [109.1162, 34.2004],
          甘肃省: [103.5901, 36.3043],
          青海省: [101.4038, 36.8207],
          宁夏回族自治区: [106.3586, 38.1775],
          新疆维吾尔自治区: [87.9236, 43.5883],
          阳江市: [111.988489, 21.86434],
          清远市: [113.062468, 23.68823],
          惠州市: [114.425285, 23.117423],
          东莞市: [113.75842, 23.027308],
          佛山市: [113.128512, 23.027759],
          肇庆市: [112.471489, 23.052889],
          汕头市: [116.688529, 23.359092],
          深圳市: [114.064552, 22.548457],
          湛江市: [110.365554, 21.276723],
          江门市: [113.087402, 22.585672],
          珠海市: [113.582555, 22.276565],
          揭阳市: [116.378512, 23.55574],
          潮州市: [116.628891, 23.663682],
          梅州市: [116.129541, 24.295231],
          汕尾市: [115.381553, 22.791263],
          广州市: [113.271431, 23.135336],
          云浮市: [112.051512, 22.920911],
          韶关市: [113.603527, 24.815881],
          河源市: [114.708592, 23.750214],
          中山市: [121.548484, 25.073115],
          北京市: [116.413384, 39.910925],
          饶平县: [116.94506450000004, 23.862357762688333],
          防城港市: [108.03926800000002, 21.93147435891838],
          通化市: [126.00664300000004, 41.952434873873955],
          黄石市: [115.02149300000002, 29.91842203209184],
          商丘市: [115.73832639378328, 34.35988962233378],
          漳州市: [117.567963, 24.373121712667597],
          三亚市: [109.37167000000001, 18.383156599678674],
          海南藏族自治州: [100.34779099999997, 35.91753453879909],
          呼伦贝尔市: [120.800763, 50.13012743465733],
          赣州市: [115.27585449999997, 25.8223691840716],
          昌吉回族自治州: [88.57422949999997, 44.304575990587814],
          常州市: [119.67084900000003, 31.607282155587807],
          池州市: [117.38907300000002, 30.206333323465344],
          牡丹江市: [129.77105999999995, 44.72090924956851],
          市辖区: [121.5511118444736, 31.35543217704241],
          邢台市: [114.80603450000001, 37.284342127897474],
          锦州市: [121.65868400000002, 41.46324678123945],
          宿州市: [117.17388749999992, 33.96572642359963],
          钦州市: [109.02731650000004, 22.132594175520133],
          荆州市: [112.66784150000005, 30.046608592484578],
          吉林市: [126.78417245151834, 43.61306641431905],
          宁波市: [121.56765600000001, 29.674867024013235],
          咸阳市: [108.41484150000001, 34.87232736271235],
          大同市: [113.57372050000001, 39.89932930185014],
          果洛藏族自治州: [99.356634, 34.08602346044571],
          秦皇岛市: [119.22043350000004, 40.02134375086799],
          临夏回族自治州: [103.27109000000006, 35.56437570342221],
          宁德市: [119.63771149999998, 26.97751822604618],
          扬州市: [119.464163, 32.818646101379656],
          萍乡市: [113.9292705, 27.483420263321488],
          广安市: [106.6261545, 30.429118760865816],
          固原市: [106.14222799999999, 35.88143499821829],
          贵港市: [109.93314699999998, 23.349286607088832],
          绥化市: [126.71423150000004, 46.818750723670675],
          长春市: [125.55471300000012, 44.21625929289104],
          黔南布依族苗族自治州: [107.25866900000003, 26.27615908438164],
          衢州市: [118.68647484488514, 28.869580064239475],
          泰州市: [120.09970049999998, 32.57761253046251],
          嘉峪关市: [98.18424199999998, 39.8272061270675],
          临汾市: [111.47455499999998, 36.16603244460434],
          南昌市: [116.00209350000006, 28.641222021597006],
          孝感市: [113.95404, 31.119878646762793],
          四平市: [124.54736499999997, 43.46978984095815],
          淮安市: [118.92388800000003, 33.40750422335413],
          温州市: [120.44895489717427, 27.828436253492345],
          廊坊市: [116.68839499999996, 39.281742884495635],
          怀化市: [109.95299449999996, 27.46222675104559],
          黄山市: [118.0528435, 29.95675123526214],
          北海市: [109.31960850000004, 21.409633986723772],
          忻州市: [112.456732, 38.90216142244396],
          兰州市: [103.58927150000001, 36.28841157109341],
          泉州市: [118.30148100000002, 25.15810510431362],
          大庆市: [124.78054100000003, 46.440808773810176],
          商洛市: [109.79960950000003, 33.76671407177316],
          玉树藏族自治州: [93.58164449999997, 34.294130897658555],
          拉萨市: [91.19001749999997, 30.151082014671708],
          遂宁市: [105.53060800000009, 30.668394741032916]
        }
      },
      {
        name: "辣椒干",
        type: "map",
        mapType: "none",
        data: [],

        markLine: {
          //划线
          smooth: true,
          effect: {
            show: true,
            scaleSize: 1,
            period: 30,
            color: "#fff",
            shadowBlur: 10
          },
          itemStyle: {
            normal: {
              borderWidth: 1,
              lineStyle: {
                type: "solid",
                shadowBlur: 10
              }
            }
          },
          data: []
        },
        markPoint: {
          label: {
            show: true,
            color: "red"
          },
          //画点
          symbol: "emptyCircle",
          // symbolSize: function(v) {
          //   return 8 + v / 10;
          // },

          symbolSize: 24,
          effect: {
            show: true,
            shadowBlur: 0
          },
          itemStyle: {
            normal: {
              label: {
                show: true
              }
            },
            emphasis: {
              label: {
                show: true,
                position: "top",
                color: "#ff0"
              }
            }
          },
          data: []
        }
      }
    ]
  };
  return option;
}
